import React, { useState } from "react";
import { Box, Drawer, IconButton, Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { GithubLogo, LinkedinLogo, List, X } from "@phosphor-icons/react";

import { NavTabV, NavTabsV } from "../components/nav-tab";

import bgPattern from "../assets/images/bg_pattern.png";

// Routes.
import { Link } from "react-router-dom";
import { PATH_WEBPAGE } from "../routes/paths";


// ---------------------------------------------------------

const MobileDrawer = () => {
  const theme = useTheme();

  const [openDrawer, setOpenDrawer] = useState(false);

  // Tabs.
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    //setValue(newValue);
    setOpenDrawer(false)
  };

  const items = [
    {
      url: "https://dinowithagun.wiki.gg/",
      label: "Wiki.gg",
    },
    // {
    //   pathName: PATH_WEBPAGE.general.playground,
    //   label: "Playground",
    // },
    // {
    //   pathName: PATH_WEBPAGE.general.contact,
    //   label: "Contact",
    // },
  ];

  return (
    <>
      <Drawer
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        anchor="right"
        PaperProps={{
          sx: {
            width: "100%",
            height: "100%",
            "&::before": {
              content: '""',
              position: "fixed",
              inset: 0,
              backgroundImage: `url(${bgPattern})`,
              backgroundRepeat: "repeat",
              opacity: 0.25,
              pointerEvents: "none",
              zIndex: -1,
            }
          }
        }}
      >
        {/* Close Button */}
        {/* ------------ */}
        <Box
          sx={{
            backgroundColor: "#e60012",
            height: 30,
          }}
        >
          <Stack
            sx={{ width: "100%", height: "100%" }}
            direction={"row"}
            alignItems={"center"}
            justifyContent={"end"}
          >
            <IconButton
              onClick={() => setOpenDrawer(!openDrawer)}
              sx={{
                color: theme.palette.text.disabled,
                "&:hover": {
                  color: theme.palette.text.primary,
                }
              }}
            >
              <X size={28} color="#fff" />
            </IconButton>
          </Stack>
        </Box>


        {/* Navigation Tabs */}
        {/* --------------- */}
        <Stack p={2} justifyContent={"space-between"} sx={{ height: "100%" }}>
          <Stack>
            <NavTabsV
              value={value}
              onChange={handleChange}
              orientation="vertical"
            >
              {items.map((item, index) => (
                item.url
                  ? // External URL.
                  <NavTabV
                    key={index}
                    label={item.label}
                    value={item.url}
                    onClick={() => {
                      window.open(item.url, "_blank");
                      setOpenDrawer(false);
                    }}
                  />
                  : // Internal path.
                  <NavTabV
                    key={index}
                    component={Link}
                    label={item.label}
                    to={item.pathName}
                    value={item.pathName}
                  />
              ))}
            </NavTabsV>
          </Stack>

          {/* Bottom Icons */}
          {/* <Stack direction={"row"} alignItems={"center"} justifyContent={"center"} spacing={2}>
            <Box>
              <IconButton
                onClick={() => window.open("https://www.linkedin.com/in/jay-raj-97508742/", "_blank")}
                sx={{
                  color: theme.palette.text.disabled,
                  "&:hover": {
                    color: theme.palette.text.primary,
                  }
                }}
              >
                <LinkedinLogo size={32} />
              </IconButton>
            </Box>
            <Box>
              <IconButton
                onClick={() => window.open("https://github.com/Vindorable", "_blank")}
                sx={{
                  color: theme.palette.text.disabled,
                  "&:hover": {
                    color: theme.palette.text.primary,
                  }
                }}
              >
                <GithubLogo size={32} />
              </IconButton>
            </Box>
          </Stack> */}
        </Stack>
      </Drawer>


      <IconButton
        onClick={() => setOpenDrawer(!openDrawer)}
        sx={{
          color: theme.palette.text.disabled,
          "&:hover": {
            color: theme.palette.text.primary,
          }
        }}
      >
        <List size={28} color="#fff" />
      </IconButton>
    </>
  );
}


// ---------------------------------------------------------

export default MobileDrawer;